function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScience = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.854,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.993,30.358C13.441,31.258 13.149,32.287 13.149,33.345C12.586,33.542 11.979,33.654 11.349,33.654C8.368,33.654 5.949,31.236 5.949,28.254L5.949,12.054C4.953,12.054 4.149,11.25 4.149,10.254C4.149,9.259 4.953,8.454 5.949,8.454L16.749,8.454C17.744,8.454 18.549,9.259 18.549,10.254C18.549,11.25 17.744,12.054 16.749,12.054L16.749,25.886L13.993,30.364L13.993,30.358ZM9.549,12.054L9.549,17.454L13.149,17.454L13.149,12.054L9.549,12.054ZM22.149,8.454L32.949,8.454C33.944,8.454 34.749,9.259 34.749,10.254C34.749,11.25 33.944,12.054 32.949,12.054L32.949,20.542L39.569,31.303C39.946,31.916 40.149,32.625 40.149,33.351C40.149,35.505 38.399,37.254 36.245,37.254L18.853,37.254C16.698,37.254 14.949,35.505 14.949,33.351C14.949,32.631 15.151,31.922 15.528,31.303L22.149,20.542L22.149,12.054C21.153,12.054 20.349,11.25 20.349,10.254C20.349,9.259 21.153,8.454 22.149,8.454ZM25.749,12.054L25.749,21.054C25.749,21.386 25.659,21.712 25.484,21.999L22.739,26.454L32.358,26.454L29.613,21.999C29.439,21.718 29.349,21.392 29.349,21.054L29.349,12.054L25.749,12.054Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScience);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/science.a4ea0dcc1e2376ab5a0b0ce3814539c0.svg";